export default "__VITE_ASSET__DE6bvOQ7__"